import { useTranslation } from 'react-i18next';

const moduleImages = [
  '/images/generated/corporate-module-1.jpg',
  '/images/generated/corporate-module-2.jpg',
  '/images/generated/corporate-module-3.jpg',
  '/images/generated/corporate-module-4.jpg',
  '/images/generated/corporate-module-5.jpg',
  '/images/generated/corporate-module-6.jpg',
];

const moduleIds = ['M1', 'M2', 'M3', 'M4', 'M5', 'M6'];
const moduleLocaleKeys = ['m1', 'm2', 'm3', 'm4', 'm5', 'm6'];

export default function TrainingModules() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('corporate.modules.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.modules.title')}
          </h2>
          {String(t('corporate.modules.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporate.modules.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {moduleIds.map((modId, idx) => (
            <div
              key={modId}
              className="card-glow group bg-background-100/60 border border-background-200/60 overflow-hidden"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={moduleImages[idx]}
                  alt={t(`corporate.modules.${moduleLocaleKeys[idx]}.title`)}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-primary-900/10"></div>
                <div className="absolute top-3 left-3 bg-accent-500/90 text-primary-900 text-[12px] tracking-[0.1em] font-bold px-2.5 py-1">
                  {modId}
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-[16px] md:text-[17px] text-foreground-900 tracking-[0.05em] mb-3 group-hover:text-accent-600 transition-colors">
                  {t(`corporate.modules.${moduleLocaleKeys[idx]}.title`)}
                </h3>
                <p className="text-[14px] md:text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {t(`corporate.modules.${moduleLocaleKeys[idx]}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
